// src/components/sections/BlogSection.js
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { fetchFeaturedArticles } from '../../services/api';
import { useLang } from '../../i18n/LanguageContext';
import { SectionHeader, ErrorBox } from '../ui';
import ArticleCard from '../ui/ArticleCard';
import styles from './BlogSection.module.css';

export default function BlogSection() {
  const { ui } = useLang();
  const { data: articles = [], isLoading, isError, refetch } = useQuery(
    'featuredArticles',
    fetchFeaturedArticles,
    { staleTime: 1000 * 60 * 5 }
  );

  return (
    <section className={styles.section} id="blog">
      <SectionHeader
        badge={ui('✦ مقالات', '✦ Articles')}
        title={ui('دانش و الهام', 'Knowledge & Inspiration')}
      />

      {isError && <ErrorBox onRetry={refetch} />}

      <div className={styles.grid}>
        {isLoading
          ? Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="skeleton" style={{ height: 320, borderRadius: 'var(--radius-lg)' }} />
            ))
          : articles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
      </div>

      <div className={styles.more}>
        <Link to="/blog" className="btn-secondary">
          {ui('مشاهده همه مقالات ←', 'View All Articles ←')}
        </Link>
      </div>
    </section>
  );
}
